/*
  Icon state
*/
export default {
  list: []
}
